export default {
      id: "dourdan_social-usage",
      viewBox: "0 0 198 52",
      url: "../dist/images/" + "sprite.svg#dourdan_social-usage",
      toString: function () {
        return this.url;
      }
    }